import React from "react";
import Select from "react-select";

export const EMBED_FORMS_ACTIVE_OPTIONS = [
    { value: true, label: "Enable" },
    { value: false, label: "Disable" },
];

const embedFormsInlineSelectStyles = {
    control: (base, state) => ({
        ...base,
        minHeight: "28px",
        height: "28px",
        flexWrap: "nowrap",
        fontSize: "13px",
        border: state.isDisabled ? "1px solid transparent" : "1px solid #aaa",
        boxShadow: "none",
        background: state.isDisabled ? "rgba(0,0,0,0.04)" : "transparent",
        cursor: state.isDisabled ? "not-allowed" : "pointer",
        opacity: state.isDisabled ? 0.6 : 1,
        pointerEvents: state.isDisabled ? "none" : undefined,
        "&:hover": { borderColor: "#aaa" },
    }),
    dropdownIndicator: (base, state) => ({
        ...base,
        padding: "0 2px",
        opacity: state.isDisabled ? 0.2 : 0.4,
    }),
    clearIndicator: () => ({
        display: "none",
        pointerEvents: "none",
    }),
    valueContainer: (base) => ({
        ...base,
        padding: "0 4px",
        flexWrap: "nowrap",
        overflow: "hidden",
        height: "26px",
        alignItems: "center",
    }),
    indicatorsContainer: (base) => ({
        ...base,
        height: "28px",
    }),
    indicatorSeparator: () => ({ display: "none" }),
    menu: (base) => ({
        ...base,
        zIndex: 9999,
        minWidth: "140px",
        fontSize: "13px",
    }),
    option: (base) => ({
        ...base,
        fontSize: "13px",
    }),
};

export function EmbedFormsActiveSelect({ isActive, disabled, onChange }) {
    const value =
        EMBED_FORMS_ACTIVE_OPTIONS.find((o) => o.value === isActive) || null;

    return (
        <Select
            options={EMBED_FORMS_ACTIVE_OPTIONS}
            value={value}
            onChange={(opt) => {
                if (opt && opt.value !== isActive) {
                    onChange(opt.value);
                }
            }}
            styles={embedFormsInlineSelectStyles}
            menuPortalTarget={document.body}
            menuPosition="fixed"
            isDisabled={disabled}
            isSearchable={false}
            classNamePrefix="inline-select"
        />
    );
}
